import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.scrollToLatest()
    requestAnimationFrame(() => this.scrollToLatest())
  }

  scrollToLatest() {
    this.element.scrollTop = this.element.scrollHeight
  }
}
